/** @jsxImportSource @emotion/react */
import Logo from "assets/Common/icons/iplay_logo 2.png";
import Logo_BajiGold from "assets/Common/images/logo-bajigold.png";
import { ReactComponent as MenuIcon } from "assets/Mobile/icons/menuIcon.svg";
import { ReactComponent as LogoutIcon } from "assets/temporary/icons/logout.svg";
import { useModalConfirm } from "components/Common/ModalConfirm";
import { isBajiGold } from "contants/common";
import { languageOptions } from "contants/list-language";
import { useAppDispatch, useAppSelector } from "hooks/app-hook";
import { useAppLogout } from "hooks/useAppLogout";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { selectIsAuthenticated } from "store/auth";
import { setOpenModal, setOpenSidebar } from "store/modal";
import { theme } from "styles/theme";

import { HeaderStyle } from "./index.style";
const Header = () => {
  const { i18n } = useTranslation(["sidebar", "login"]);

  const dispatch = useAppDispatch();

  const isAuth = useAppSelector(selectIsAuthenticated);
  const { contextHolder, modalConfig } = useModalConfirm();
  const onLogout = useAppLogout();

  const showConfirmLogout = () => {
    modalConfig({
      title: i18next.t("login:Logout"),
      onSuccess: () => {
        onLogout();
      },
    });
  };

  const imageLanguage = languageOptions.find(
    (itemFind) => itemFind.id === i18n.language
  );

  return (
    <div css={HeaderStyle.container}>
      <div
        onClick={() => dispatch(setOpenSidebar(true))}
        css={HeaderStyle.menuButton}
      >
        <MenuIcon
          width={"1.5rem"}
          height={"1.5rem"}
          fill={theme.colors.darkGreen}
        />
      </div>
      <Link css={HeaderStyle.logoApp} to={"/"}>
        <img src={isBajiGold ? Logo_BajiGold : Logo} alt="..." />
      </Link>
      <div css={HeaderStyle.menuLanguage}>
        {/* {isAuth && <span onClick={showConfirmLogout}> {t("Logout")}</span>} */}
        {isAuth && <LogoutIcon onClick={showConfirmLogout} />}
        <img
          src={imageLanguage?.picture}
          alt=""
          onClick={() => dispatch(setOpenModal("language"))}
        />
      </div>
      {contextHolder}
    </div>
  );
};

export default Header;
